module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921092334_T.3625089a.jpg";